'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseCharge', ['$scope', '$stateParams', '$q', '$filter', '$injector', '$state', 'LicenseCharges', 'FBQuestions', '$timeout', 'LicenseChargeCalculatedFields',
        function ($scope, $stateParams, $q, $filter, $injector, $state, LicenseCharges, FBQuestions, $timeout, LicenseChargeCalculatedFields) {
            $scope.resetLicense();
            $scope.license_charge = $stateParams.license_charge;
            $scope.licenseChargeID = $stateParams.licenseChargeID;
            $scope.messages = [];
            $scope.licenseChargeCalculatedFields = [];
            var serviceOptions = {};

            var promises = [];

            $scope.schemes = [
                { id: 1, name: 'Flat' },
                { id: 0, name: 'Type' },
                { id: 2, name: 'Conditional' },
                { id: 3, name: 'Unit Based' }
            ];
            $scope.andOrOptions = [
                { id: true, name: 'and' },
                { id: false, name: 'or' }
            ];
            $scope.leftParenOptions = [
                { id: 0, name: '' },
                { id: 1, name: '(' },
                { id: 2, name: '((' }
            ];
            $scope.rightParenOptions = [
                { id: 0, name: '' },
                { id: 1, name: ')' },
                { id: 2, name: '))' }
            ];
            $scope.saving = false;
            $scope.deleting = false;
            $scope.loading = true;

            $scope.$watch('licenseLoading', function (licenseLoading) {
                if (licenseLoading == false) {
                    $scope.parameters = { license_id: $scope.licenseID, license_category_id: $scope.license != null ? $scope.license.license_category_id : null };
                }
            })

            if ($stateParams.licenseChargeID != null) {
                // Get Charge
                promises.push(LicenseCharges.getByID($stateParams.licenseChargeID).then(function (charge) {
                    $scope.license_charge = charge;
                }));
            } else {
                $scope.license_charge = { name: '', license_id: $scope.licenseID, code: null, value: null, question_criteria: [{ id: guid(), question_id: null, Sort_Order: 1 }] };
            }
            // Get Questions
            promises.push(FBQuestions.get({ licenseID: $scope.licenseID }).then(function (questions) {
                $scope.questions = questions;
                $scope.questions.forEach(function (question) {
                    question.group = question.form + ': ' + question.page + ': ' + question.section;
                });
            }));
            promises.push(LicenseChargeCalculatedFields.get($scope.licenseID).then(function (result) {
                if (result != null) {
                    $scope.licenseChargeCalculatedFields = result;
                }
            }));
            $q.all(promises).then(function () {
                serviceOptions = {};
                $scope.license_charge.question_criteria.forEach(function (criterion) {
                    $scope.questionChange($filter('filter')($scope.questions, { id: criterion.question_id })[0], criterion, true);
                });
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });

            $scope.schemaChange = function (license_charge) {
                if (license_charge != null) {
                    // clearing the other fields when we make a schema change
                    license_charge = {
                        id: license_charge.id,
                        name: license_charge.name,
                        code: license_charge.code,
                        value: license_charge.value,
                        license_id: license_charge.license_id,
                        flat_fee: license_charge.flat_fee
                    }
                    license_charge.question_criteria = [{ id: guid(), question_id: null, Sort_Order: 1 }];

                    $scope.license_charge = license_charge;
                }
            }

            function doParenthesesMatch(questionArr) {
                var parenthesisString = '';
                for (var i = 0; i < questionArr.length; i++) {
                    // query for these since hlp-select nests the select which we extract the value from
                    var left = document.querySelectorAll("[id='leftParentheses_" + i + "'");
                    if (left != null && left.length > 0) {
                        left = left[1].options[left[1].selectedIndex];
                    } else {
                        continue;
                    }

                    var right = document.querySelectorAll("[id='rightParentheses_" + i + "'");
                    if (right != null && right.length > 0) {
                        right = right[1].options[right[1].selectedIndex];
                    } else {
                        continue;
                    }

                    left = (!left.innerHTML.includes('(')) ? '' : left.innerHTML;
                    right = (!right.innerHTML.includes(')')) ? '' : right.innerHTML;
                    parenthesisString += left + right;
                }

                var parenthesisStack = [];
                for (var i = 0; i < parenthesisString.length; i++) {
                    var char = parenthesisStack[parenthesisStack.length - 1];
                    if (parenthesisString.charAt(i) == "(") {
                        parenthesisStack.push(parenthesisString.charAt(i));
                    } else if (char == "(" && parenthesisString.charAt(i) == ")") {
                        parenthesisStack.pop();
                    } else {
                        return false;
                    }
                }
                window.scrollTo(0, 0);
                return (parenthesisStack.length) ? false : true;
            }

            $scope.save = function () {
                $scope.saving = true;
                $scope.messages = [];
                if (doParenthesesMatch($scope.license_charge.question_criteria)) {
                    LicenseCharges.save($scope.license_charge).then(function (license_charge) {
                        updateArray($scope.license.license_charges, license_charge);
                        updateArray($scope.masterLicense.license_charges, license_charge);
                        $state.go('internal.licensing.license.charges', { id: $scope.licenseID });
                    });
                } else {
                    $scope.messages.push("Validation failed! Please ensure parenthesis are valid.");
                }
                $scope.saving = false;
            }

            $scope.delete = function () {
                $scope.deleting = true;

                if (window.confirm('Are you sure you want to delete this license charge?')) {
                    LicenseCharges.delete($stateParams.licenseChargeID).then(function () {
                        updateArray($scope.license.license_charges, $scope.license_charge, true);
                        updateArray($scope.masterLicense.license_charges, $scope.license_charge, true);
                        $scope.deleting = false;
                        $state.go('internal.licensing.license.charges', { id: $scope.licenseID });
                    })
                }
                else {
                    $scope.deleting = false;
                }
            }

            // When from question changes. We need to update the operators and values dropdown
            $scope.questionChange = function (question, criteria, initial) {
                criteria.loading = true;
                if (question != null) {
                    criteria.type = question.type;
                    if (question.type == 'date') {
                        criteria.operators = [
                            { id: '=', name: '=' },
                            { id: '<>', name: '<>' },
                            { id: '>', name: '>' },
                            { id: '<', name: '<' }
                        ];
                    } else if (question.name == "Course") {
                        criteria.operators = [
                            { id: '=', name: '=' },
                            { id: '<>', name: '<>' },
                            { id: 'like', name: 'contains' }
                        ];
                    } else {
                        criteria.operators = [
                            { id: '=', name: '=' },
                            { id: '<>', name: '<>' }
                        ];
                    }

                    criteria.options = [];
                    criteria.selectValue = 'id';
                    criteria.selectShow = 'name';

                    if (!initial) {
                        criteria.value = null;
                    }

                    if (question.type == 'application_type') {
                        question.service = 'ApplicationTypes';
                        criteria.selectShow = 'label';
                    }

                    if (question.type == 'yesno') {
                        criteria.options = [
                            { id: true, name: 'Yes' },
                            { id: false, name: 'No' }
                        ];
                        criteria.loading = false;
                    }
                    else if (question.service != null) {
                        if (serviceOptions[criteria.question_id] == null) {
                            serviceOptions[criteria.question_id] = [];

                            var service = $injector.get(question.service);
                            if (question.method == null || question.method == 'search') {
                                question.method = 'get';
                            }

                            // DOUBLE CHECK IF THIS IS WANTED IN ALL CASES
                            // Also check if we want to pass in the licene id, but ONLY for questions where the license_category_id == license.license_category_id
                            if (question.license_category_id != null) {
                                $scope.parameters['license_category_id'] = question.license_category_id;
                                // used for license levels filter, we're taking advantage of scope inheritance here
                                // but if they don't match, we don't want the license_id when it's calling licensecategorylevels.get 
                                // or it will limit the levels to the license's levels, and ignore the certification dataset's license category.
                                if ($scope.license.license_category_id == question.license_category_id) {
                                    $scope.parameters['license_id'] = $scope.license.id;
                                }
                                else if (question.service == 'LicenseCategoryLevels' && question.method == 'get') {
                                    $scope.parameters['license_id'] = null;
                                }
                            }

                            service[question.method](angular.copy($scope.parameters)).then(function (data) {
                                criteria.options = angular.copy(data);
                                var timeoutArray = [];
                                timeoutArray.push($timeout(function () {
                                    criteria.loading = false;
                                }, 0));

                                serviceOptions[criteria.question_id].forEach(function (c) {
                                    c.options = data;
                                    timeoutArray.push($timeout(function () {
                                        c.loading = false;
                                    }, 0));
                                });
                                serviceOptions[criteria.question_id] = null;

                                $scope.$on('$destroy', function () {
                                    timeoutArray.forEach(function (timer) {
                                        $timeout.cancel(timer);
                                    });
                                });
                            });
                        }
                        else {
                            serviceOptions[criteria.question_id].push(criteria);
                        }
                    }
                    else if (question.options != null) {
                        if (angular.isString(question.options)) {
                            question.options.split(',').forEach(function (value) {
                                criteria.options.push({ id: value.trim(), name: value.trim() });
                            })
                        } else {
                            criteria.options = question.options;
                        }

                        criteria.loading = false;
                    }
                    else {
                        criteria.loading = false;
                    }
                } else {
                    criteria.loading = false;
                }
            }

            // When from operator changes erase value to not show guid
            $scope.operatorChange = function (criteria) {
                if (criteria.operator == "like") {
                    criteria.value = null;
                }
            }

            $scope.add = function (array, item) {
                var addedIdx = array.indexOf(item) + 1;
                array.splice(addedIdx, 0, { and_flag: true, left_parenthesis: 0, operator: '=', right_parenthesis: 0, sort_order: item.sort_order + 1 });
                array = array.map(function (elem, idx) {
                    if (idx > addedIdx) {
                        elem.sort_order = elem.sort_order + 1;
                    }
                    return elem;
                });
            }

            $scope.remove = function (array, item) {
                var removedIdx = array.indexOf(item);
                array.splice(removedIdx, 1);
                // really wish I had arrow functions from ES6 here
                array = array.map(function (elem, idx) {
                    if (idx + 1 > removedIdx) {
                        elem.sort_order = elem.sort_order - 1;
                    }
                    return elem;
                });
            }

            $scope.reorder = function (array, item) {
                if (item.sort_order == null || isNaN(item.sort_order)) return;

                // sort order should already be changed
                var copyArray = angular.copy(array);
                var oldIdx = array.indexOf(item);
                var newIdx = item.sort_order - 1;
                var splicedItem = copyArray.splice(oldIdx, 1).pop();
                if (item.sort_order = 1) splicedItem.and_flag = null; // 1st item should NOT have an and_flag property
                copyArray = copyArray.map(function (elem) {
                    if (elem.sort_order - 1 >= oldIdx && elem.sort_order - 1 < newIdx) {
                        elem.sort_order = elem.sort_order - 1;
                    }
                    if (elem.sort_order - 1 < oldIdx && elem.sort_order - 1 >= newIdx) {
                        elem.sort_order = elem.sort_order + 1;
                    }
                    return elem;
                });
                copyArray.splice(newIdx, 0, splicedItem);
                $scope.condition.question_criteria = copyArray;
            }
        }])
    ;